export default __webpack_public_path__ + "media/images/tree-decor-e3f202e6b97ec19d074c125bccddf04a.png";